export const initialUrl = '/Home'; // this url will open after login
export const initialOuterUrl = '/login'; // this url will open after logout

export enum TipologiaErogazioneVisita {
    AMBULATORIALE = "AMBULATORIALE",
    DOMICILIARE = "DOMICILIARE",
    ONLINE = "ONLINE",
}
export enum CategoriaPrestazione {
    REFERTAZIONE = "REFERTAZIONE",
    PRESCRIZIONE = "PRESCRIZIONE"
}
export enum NomiPuntiDiErogazioneStanzeVirtuali {
    Teleconsulto = "Teleconsulto",
    VisitaDomiciliare = "Visita Domiciliare",
    Refertazione = "Refertazione"
}

export enum FasciaOrariaDomiciliare {
    MATTINA = "MATTINA",
    POMERIGGIO = "POMERIGGIO",
    SERA = "SERA",
    NOTTE = "NOTTE",
}

export const TipologiaErogazioneVisitaId = [
    process.env.REACT_APP_MODALITA_EROGAZIONE_AMBULATORIALE_ID!,
    process.env.REACT_APP_MODALITA_EROGAZIONE_DOMICILIARE_ID!,
    process.env.REACT_APP_MODALITA_EROGAZIONE_ONLINE_ID!,
]

export const ModalitaErogazioneId: Record<TipologiaErogazioneVisita, string> = {
    AMBULATORIALE: process.env.REACT_APP_MODALITA_EROGAZIONE_AMBULATORIALE_ID!,
    DOMICILIARE: process.env.REACT_APP_MODALITA_EROGAZIONE_DOMICILIARE_ID!,
    ONLINE: process.env.REACT_APP_MODALITA_EROGAZIONE_ONLINE_ID!,
}

export enum RoutePermittedRole {
    // Admin = 'admin',
    // User = 'user',
    
    Admin = 'Admin',
    Gestore = "Gestore",
    Amministrativo = "Amministrativo",
    Dipendente = "Dipendente",
    Freelancer = "Freelancer",
    CentraleOperativa = "CentraleOperativa",
}


export type ModalitaPagamentoString =
  | 'NonPagato'
  | 'Contanti'
  | 'Carta'
  | 'CreditoAssistito'
  | 'Altro'
  // | "Paypal"
  // | "Satispay"
  | 'SatisPay_Differito'
  | 'SatisPay_Immediato'
  | 'PayPal_Carta_Immediato'
  | 'PayPal_Differito'
  | 'PayPal_Immediato'
  | 'PayPal_Carta_Differito'

export const ModalitaPagamento: Record<ModalitaPagamentoString, string> = {
    NonPagato: process.env.REACT_APP_MODALITA_PAGAMENTO_NON_PAGATO_ID!,
    Contanti: process.env.REACT_APP_MODALITA_PAGAMENTO_CONTANTI_ID!,
    Carta: process.env.REACT_APP_MODALITA_PAGAMENTO_CARTA_ID!,
    
    // Paypal: process.env.REACT_APP_MODALITA_PAGAMENTO_PAYPAL_ID!,
    // Satispay: process.env.REACT_APP_MODALITA_PAGAMENTO_SATISPAY_ID!,
    
    SatisPay_Differito: process.env.REACT_APP_MODALITA_PAGAMENTO_SATISPAY_DIFFERITO_ID!,
    SatisPay_Immediato: process.env.REACT_APP_MODALITA_PAGAMENTO_SATISPAY_IMMEDIATO_ID!,
    
    PayPal_Carta_Immediato: process.env.REACT_APP_MODALITA_PAGAMENTO_PAYPAL_CARTA_IMMEDIATO_ID!,
    PayPal_Differito: process.env.REACT_APP_MODALITA_PAGAMENTO_PAYPAL_DIFFERITO_ID!,
    PayPal_Immediato: process.env.REACT_APP_MODALITA_PAGAMENTO_PAYPAL_IMMEDIATO_ID!,
    PayPal_Carta_Differito: process.env.REACT_APP_MODALITA_PAGAMENTO_PAYPAL_CARTA_DIFFERITO_ID!,

    CreditoAssistito: process.env.REACT_APP_MODALITA_PAGAMENTO_CREDITO_ASSISTITO_ID!,

    Altro: process.env.REACT_APP_MODALITA_PAGAMENTO_ALTRO_ID!,
}

export const GOOGLE_API_KEY = 
    process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_GOOGLE_API_DEV_KEY!
    : process.env.REACT_APP_GOOGLE_API_PROD_KEY!

export const isAppDevelopment = process.env.NODE_ENV === "development"